module.exports = __webpack_public_path__ + "static/media/dripicons-v2.7e12564e.eot";